import { render, staticRenderFns } from "./store-item.vue?vue&type=template&id=6cc48b12&"
import script from "./store-item.vue?vue&type=script&lang=js&"
export * from "./store-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports